        <nb-card class="search-box">
            <nb-card-body class="example-items-rows">
               <h3> Search for your favourite movie! </h3>
               <div class="search-container">
               <nb-form-field class="form-container">
                <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
                <input [(ngModel)]="searchTitle" type="search" nbInput placeholder="Search" (keydown.enter)="searchMovie(searchTitle)">
              </nb-form-field>
              <button
                    (click)="searchMovie(searchTitle)"
                    nbButton
                    status="danger"
                    class="search-btn"
                    >
                    Search
                </button>
            </div>
            </nb-card-body>
        </nb-card>
        
        <app-movie [moviedata]="movieList"></app-movie>
